export function insertZeros(arr: number[]): number[] {
  return arr.flatMap((num) => [num, 0]).slice(0, -1);
}
